module.exports = __webpack_public_path__ + "img/核心技术首图bg.bc11c4c9.png";